import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Target(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Target", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        fillRule: "evenodd",
        d: "M45 24.42c0 9.067-7.35 16.419-16.419 16.419-9.068 0-16.419-7.352-16.419-16.42C12.162 15.351 19.513 8 28.582 8 37.65 8 45 15.351 45 24.42Zm-4.278 0c0 6.705-5.436 12.142-12.142 12.142-6.705 0-12.142-5.437-12.142-12.142 0-6.706 5.437-12.142 12.142-12.142 6.706 0 12.142 5.436 12.142 12.142Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        fillRule: "evenodd",
        d: "M36.444 24.419a7.865 7.865 0 1 1-15.73 0 7.865 7.865 0 0 1 15.73 0Zm-4.278 0a3.587 3.587 0 1 1-7.175 0 3.587 3.587 0 0 1 7.175 0Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.dark, d: "M3 25.506h25.238a1.083 1.083 0 1 0 0-2.167H3v2.167Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.dark,
        d: "M3 23.339V21.77c0-.607.492-1.099 1.099-1.099h2.874c.437 0 .851.197 1.127.536l1.736 2.13H3Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M3 25.505v1.568a1.1 1.1 0 0 0 1.099 1.1h2.874c.437 0 .851-.197 1.127-.536l1.736-2.131H3Z"
      }
    )
  ] });
}
Target.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Target"
};
validateTidalLicense();
export {
  Target
};
//# sourceMappingURL=Target.js.map
